
import Vue from 'vue'
import ExpiredSVG from '../components/svg/expired.vue'
import { useAppStore } from '@/store/app'

export default Vue.extend({
  name: 'Finished',
  components: {
    ExpiredSVG
  },
  setup () {
    const app = useAppStore()

    return {
      app
    }
  },
  data () {
    return {
      color: ''
    }
  },
  beforeMount () {
    this.color = this.app.primaryColor
  }
})
